<template>
  <div class="d-flex justify-content-center align-items-center min-vh-100 bg-light">
    <div class="card shadow p-4" style="max-width: 500px; width: 100%;">
      <h3 class="text-center mb-3">Aktivasi Akun</h3>

      <div v-if="loading" class="text-center">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-2">Memproses aktivasi...</p>
      </div>

      <div v-else-if="successMessage" class="alert alert-success text-center" v-html="successMessage"></div>
      <div v-else-if="errorMessage" class="alert alert-danger text-center" v-html="errorMessage"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()
const successMessage = ref('')
const errorMessage = ref('')
const loading = ref(true)

const activateAccount = async (token) => {
  try {
    const response = await axios.post('https://metatekapps.metateknologi.com/api-vms-activation.php', {
      token: token
    })

    if (response.data.status === 200) {
      successMessage.value = '✅ Aktivasi berhasil! Anda akan diarahkan ke halaman login...'

      // Redirect setelah 3 detik
      setTimeout(() => {
        router.push('/')
      }, 3000)
    } else {
      errorMessage.value = '❌ Token tidak valid atau sudah digunakan.'
    }
  } catch (err) {
    errorMessage.value = err.response?.data?.message || 'Terjadi kesalahan saat aktivasi.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')

  if (token) {
    activateAccount(token)
  } else {
    loading.value = false
    errorMessage.value = 'Token aktivasi tidak ditemukan di URL.'
  }
})
</script>

<style scoped>
.bg-light {
  background-color: #f8f9fa;
}
</style>
